import { useLocation, Navigate } from "react-router-dom";
import { useUserContext } from "../../contexts/userProvider";
import { Spin } from "antd";

export function PublicRoute({ children }: { children: JSX.Element }) {
  let location = useLocation();
  const { user, loading } = useUserContext();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  if (user) {
    const prevLocation = location.state?.from || "/dashboard";
    return <Navigate to={prevLocation} state={{ from: location }} replace />;
  }

  return children;
}
